import firebase from "firebase";

// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
var config = {
  apiKey: "AIzaSyC6ScEOwW_jIWPYifPrloCA8fiz1Ej-dEw",
  authDomain: "interview-buddy-713d1.firebaseapp.com",
  projectId: "interview-buddy-713d1",
  storageBucket: "interview-buddy-713d1.appspot.com",
  messagingSenderId: "528565308763",
  appId: "1:528565308763:web:01be3db08aae9c6aa29e7e",
  measurementId: "G-GLHG1T5BP0",
};

// Initialize Firebase

firebase.initializeApp(config);
export default firebase;
